export default "__VITE_ASSET__jfGgi9Kc__"